<mat-list-item (click)="onSendFeedback()">
    <mat-icon matListIcon>feedback</mat-icon>
    <a matLine>Send Feedback</a>
</mat-list-item>
